import { START_IO_SIM_RUN } from "../actionTypes";

export const startIoSimRun = (verificationId, workflowTypes) => ({
  type: START_IO_SIM_RUN,
  verificationId,
  workflowTypes
})